export const VALIDATION_TOKEN_REQUEST = 'VALIDATION_TOKEN_REQUEST'
export const VALIDATION_TOKEN_RESET = 'VALIDATION_TOKEN_RESET'
export const VALIDATION_TOKEN_EXPIRED = 'VALIDATION_TOKEN_EXPIRED'
export const VALIDATION_TOKEN_SUCCESS = 'VALIDATION_TOKEN_SUCCESS'
export const VALIDATION_TOKEN_ERROR = 'VALIDATION_TOKEN_ERROR'
